import cpStorage from "./cpStorage";

const APP_STATE_KEY = "appState";

/**
 * Single app-wide state object persisted to localStorage (base64-encoded).
 * Add new keys here instead of creating individual storage entries.
 */
export interface AppState {
  adminLayoutEnabled?: boolean;
  adminDrawerExpanded?: boolean;
  userDrawerExpanded?: boolean;
  lastVisitedPage?: string;
}

export const getAppState = (): Promise<AppState> =>
  cpStorage.getItemDecoded<AppState>(APP_STATE_KEY).then((s) => s ?? {});

export const updateAppState = async (
  partial: Partial<AppState>,
): Promise<void> => {
  const current = await getAppState();
  await cpStorage.setItemEncoded(APP_STATE_KEY, { ...current, ...partial });
};

export const clearAppState = (): Promise<void> =>
  cpStorage.removeItem(APP_STATE_KEY);
